import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';

interface Group { title: string; items: { keys: string[]; label: string }[] }

const GROUPS: Group[] = [
  {
    title: 'Generale',
    items: [
      { keys: ['⌘', 'K'], label: 'Apri command palette' },
      { keys: ['?'], label: 'Mostra questa guida' },
      { keys: ['Esc'], label: 'Chiudi finestra / annulla' },
      { keys: ['/'], label: 'Focus barra di ricerca' },
    ],
  },
  {
    title: 'Composizione',
    items: [
      { keys: ['c'], label: 'Scrivi nuovo messaggio' },
      { keys: ['r'], label: 'Rispondi al thread aperto' },
    ],
  },
  {
    title: 'Azioni sul thread',
    items: [
      { keys: ['e'], label: 'Archivia' },
      { keys: ['#'], label: 'Sposta nel cestino' },
      { keys: ['s'], label: 'Aggiungi/togli stella' },
    ],
  },
  {
    title: 'Navigazione',
    items: [
      { keys: ['j'], label: 'Messaggio successivo' },
      { keys: ['k'], label: 'Messaggio precedente' },
      { keys: ['u'], label: 'Mostra solo non letti' },
      { keys: ['g', 'i'], label: 'Vai a Inbox' },
      { keys: ['g', 's'], label: 'Vai a Inviati' },
      { keys: ['g', 'd'], label: 'Vai a Bozze' },
      { keys: ['g', 't'], label: 'Vai al Cestino' },
    ],
  },
];

export function ShortcutsHelp({ open, onOpenChange }: { open: boolean; onOpenChange: (v: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Scorciatoie da tastiera</DialogTitle>
          <DialogDescription>
            Per chi tiene le mani sulla tastiera. Premi {kbd('?')} ovunque per riaprire questa guida.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6 mt-2">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-2">
                {g.title}
              </div>
              <div className="space-y-1.5">
                {g.items.map((it, i) => (
                  <div key={i} className="flex items-center justify-between text-sm">
                    <span>{it.label}</span>
                    <span className="flex items-center gap-1">
                      {it.keys.map((k, j) => (
                        <kbd
                          key={j}
                          className="text-[11px] font-mono bg-muted border rounded px-1.5 py-0.5 min-w-[22px] text-center"
                        >
                          {k}
                        </kbd>
                      ))}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <Separator className="mt-4" />
        <div className="text-xs text-muted-foreground">
          Le scorciatoie funzionano quando il focus non e` su un campo di testo.
        </div>
      </DialogContent>
    </Dialog>
  );
}

function kbd(text: string) {
  return (
    <kbd className="text-[11px] font-mono bg-muted border rounded px-1.5 py-0.5">
      {text}
    </kbd>
  );
}
